import React, { Component, Suspense, lazy } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom'
import './App.css';
import './components/Pages/PolicyPage.css';
import axiosConfig from './axiosConfig';

import Home from './components/Home/Index'
import Header from './components/Header'

import Footer from './components/Footer'

import Error404 from './Error404';
import { connect } from 'react-redux'
import { incrementCart, decrementCart, addToWishlist, removeFromWishlist, replaceWishlist, replaceCart, replacePoints } from './actions'
import { Helmet } from 'react-helmet-async';
import SimpleSpinner from './components/SimpleSpinner';
import FullScreenLoader from './components/Loaders/FullScreenLoader';

const ProductListing = lazy(() => import('./components/Products/ProductListing'));
const Product = lazy(() => import('./components/Products/Product'));
const Cart = lazy(() => import('./components/Cart/Cart'));
const EmptyCart = lazy(() => import('./components/Cart/EmptyCart'));
const Store = lazy(() => import('./components/Store'));
const AccountCreate = lazy(() => import('./components/Account/AccountCreate'));
const AccountDetailsListing = lazy(() => import('./components/Account/AccountDetailsListing'));
const Login = lazy(() => import('./components/Account/Login'));
const ForgotPassword = lazy(() => import('./components/Account/ForgotPassword'));
const ForgotPasswordConfirm = lazy(() => import('./components/Account/ForgotPasswordConfirm'));
const Logout = lazy(() => import('./components/Account/Logout'));
const Checkout = lazy(() => import('./components/Checkout'));
const Invoice = lazy(() => import('./components/Invoice'));
const AboutUs = lazy(() => import('./components/Pages/AboutUs'));
const ContactUs = lazy(() => import('./components/Pages/ContactUs'));
const RefundPolicy = lazy(() => import('./components/Pages/RefundPolicy'));
const PrivacyPolicy = lazy(() => import('./components/Pages/PrivacyPolicy'));
const ShippingPolicy = lazy(() => import('./components/Pages/ShippingPolicy'));



class App extends Component {
  constructor(props) {
    super(props)

    window.AppComponent = this


    this.state = {
      isLoggedIn: false,
      userdata: {},
      isAppLoading: true,
      loadingMessage: 'Loading...',
      routeChanging: false,
    }

    // Expose loading function to window
    window.setAppLoading = (loading, message = 'Loading...') => {
      this.setState({
        isAppLoading: loading,
        loadingMessage: message
      });
    };

    if (localStorage.getItem('userToken')) {
      window.setAppLoading(true, 'Authenticating user...');

      axiosConfig.get('/api/account-details?app-js')
        .then(res => {
          if (res) {
            let res_data = {
              first_name: res.data.data.first_name,
              last_name: res.data.data.last_name,
            }

            const userEmail = res.data.data.email;
            if (userEmail) {
              localStorage.setItem('user_email', userEmail);
              const cartItems = this.props.cart_reducer || [];
              const hasDifferentUserItem = cartItems.some(item => item.user_email && String(item.user_email) !== String(userEmail));
              if (hasDifferentUserItem) {
                this.props.replaceCart([]);
              } else {
                const updatedCart = cartItems.map(item => ({ ...item, user_email: userEmail }));
                this.props.replaceCart(updatedCart);
              }
            }

            this.setState({
              isLoggedIn: true,
              userdata: res_data
            }, () => {
              if (this.state.isLoggedIn) {
                this.getWishList();
                this.getPointsSummary();
              }
              
              setTimeout(() => {
                window.setAppLoading(false);
              }, 1000);
            })

            let appState = {
              isLoggedIn: true
            };
            localStorage["appState"] = JSON.stringify(appState);
          }
          else {
            this.setState({
              isLoggedIn: false,
            })

            let appState = {
              isLoggedIn: false
            };
            localStorage.removeItem("userToken")
            localStorage["appState"] = JSON.stringify(appState);
            
            setTimeout(() => {
              window.setAppLoading(false);
            }, 500);
          }

        })
        .catch(err => {
          if (err.response && err.response.status === 500) {
            this.setState({
              isLoggedIn: false
            })

            let appState = {
              isLoggedIn: false
            };

            localStorage["appState"] = JSON.stringify(appState);
          }
          else if (err.response && err.response.status === 401 && err.response.data === "Unauthorized.") {
            this.setState({
              isLoggedIn: false
            })

            let appState = {
              isLoggedIn: false
            };
            localStorage.removeItem("userToken")
            localStorage["appState"] = JSON.stringify(appState);
          }
          
          setTimeout(() => {
            window.setAppLoading(false);
          }, 500);
        })
    }
    else {
      this.setState({
        isLoggedIn: false
      })

      let appState = {
        isLoggedIn: false
      };

      localStorage["appState"] = JSON.stringify(appState);

      setTimeout(() => {
        window.setAppLoading(false);
      }, 500);

      // this.props.history.push('/login')
    }

    this.updateParentUserDataState = this.updateParentUserDataState.bind(this)

  }

  async getPointsSummary() {

    await axiosConfig.get(`/api/points-summary`)
      .then(res => {
        if (res.data.success) {
          this.props.replacePoints(res.data.data);
        }
      })
      .catch(err => {
      })
  }

  updateParentUserDataState(res) {
    if (res.isLoggedIn) {
      this.setState({
        isLoggedIn: true,
      }, () => {
        this.getWishList();
        this.getPointsSummary();

        axiosConfig.get('/api/account-details?app-js')
          .then(accountRes => {
            if (accountRes && accountRes.data && accountRes.data.data) {
              const userEmail = accountRes.data.data.email;
              if (userEmail) {
                localStorage.setItem('user_email', userEmail);
                const cartItems = this.props.cart_reducer || [];
                const hasDifferentUserItem = cartItems.some(item => item.user_email && String(item.user_email) !== String(userEmail));
                if (hasDifferentUserItem) {
                  this.props.replaceCart([]);
                } else {
                  const updatedCart = cartItems.map(item => ({ ...item, user_email: userEmail }));
                  this.props.replaceCart(updatedCart);
                }
              }
            }
          })
          .catch(() => {});
      })
    } else {
      this.setState({
        isLoggedIn: false,
      })
    }
  }

  componentDidMount() {
    // this.resetJqueries();
    // if( this.state.isLoggedIn ) {
    //   this.getWishList();
    // }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location && prevProps.location && this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ routeChanging: true }, () => {
        setTimeout(() => {
          this.setState({ routeChanging: false });
        }, 850);
      });
      window.scrollTo(0, 0);
    }
  }

  // resetJqueries() {

  //   // <script defer src="js/vendor-special/lazysizes.min.js"></script>
  //   // <script defer src="js/vendor-special/ls.bgset.min.js"></script>
  //   // <script defer src="js/vendor-special/ls.aspectratio.min.js"></script>
  //   // <script defer src="js/vendor-special/jquery.min.js"></script>
  //   // <script defer src="js/vendor-special/jquery.ez-plus.js"></script>
  //   // <script defer src="js/vendor-special/instafeed.min.js"></script>
  //   // <script defer src="js/vendor/vendor.min.js"></script>
  //   // <script defer src="js/app-html.js"></script>
  //   let arr = [
  //     "js/vendor-special/lazysizes.min.js",
  //     "js/vendor-special/ls.bgset.min.js",
  //     "js/vendor-special/ls.aspectratio.min.js",
  //     "js/vendor-special/jquery.min.js",
  //     "js/vendor-special/jquery.ez-plus.js",
  //     "js/vendor-special/instafeed.min.js",
  //     "js/vendor/vendor.min.js",
  //     "js/app-html.js"
  //   ]

  //   arr.forEach(el => {
  //     if (document.getElementById(el)) {
  //       document.getElementById(el).remove()
  //     }
  //     var script = document.createElement('script');
  //     script.id = el
  //     script.src = el
  //     script.defer = true
  //     document.getElementsByTagName('body')[0].appendChild(script);

  //     script.onload = function () {

  //       // this.resetNestable();  
  //     }
  //   })


  //   // if (document.getElementById("sliders-script")) {
  //   //   document.getElementById("sliders-script").remove()
  //   // }
  //   // var script = document.createElement('script');
  //   // script.id = "sliders-script"
  //   // script.src = "/js/app-html.js";
  //   // script.defer = true
  //   // document.getElementsByTagName('body')[0].appendChild(script);

  //   // script.onload = function () {

  //   //   // this.resetNestable();  

  //   // }

  // }

  async getWishList() {
    await axiosConfig.get("/api/wishlists")
      .then(res => {
        if (res.data.success) {
          this.props.replaceWishlist(res.data.data);
        }
      })
      .catch(err => {

      })
  }


  resetJqueries() {
    let arr = [
      "/js/vendor-special/lazysizes.min.js",
      "/js/vendor-special/ls.bgset.min.js",
      "/js/vendor-special/ls.aspectratio.min.js",
      "/js/vendor-special/jquery.min.js",
      "/js/vendor-special/jquery.ez-plus.js",
      "/js/vendor/vendor.min.js",
      "/js/app-html.js"
    ]

    // if(this.state.featured_products.length == 0){
    //     arr.push("add_pfeaurd_prod")
    // }

    arr.forEach(el => {
      if (document.getElementById(el)) {
        document.getElementById(el).remove()
      }
      // var script = document.createElement('script');
      // script.id = el
      // script.src = el
      // // script.defer = true
      // // script.async = true
      // document.getElementsByTagName('body')[0].appendChild(script);

      // script.onload = function () {
      // }
    })

  }



  render() {

    return (
      <div className="body-wrapper">
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="author" content="MERCHANT BITGOFULFILL" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>
            Merchant Bitgofulfill
          </title>
        </Helmet>

        <FullScreenLoader loading={this.state.isAppLoading} message={this.state.loadingMessage} />

        {this.state.routeChanging && (
          <>
            <style dangerouslySetInnerHTML={{__html: `
              @keyframes route-progress {
                0% { width: 0%; opacity: 1; }
                30% { width: 40%; opacity: 1; }
                70% { width: 85%; opacity: 1; }
                100% { width: 100%; opacity: 0; }
              }
            `}} />
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              height: '3px',
              background: 'linear-gradient(90deg, #5578f4 0%, #00d2ff 50%, #5578f4 100%)',
              zIndex: 999999,
              width: '100%',
              animation: 'route-progress 0.85s cubic-bezier(0.1, 0.8, 0.3, 1) forwards',
              boxShadow: '0 1px 8px rgba(85, 120, 244, 0.4)'
            }} />
          </>
        )}

        <Header
          isLoggedIn={this.state.isLoggedIn}
          updateParentUserDataState={this.updateParentUserDataState}
        />
        {/* <AccountSidebar/> */}
        <Suspense fallback={<SimpleSpinner />}>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route
              exact path="/product-listing">
              <ProductListing />
            </Route>
            <Route exact path="/product">
              <Product />
            </Route>
            <Route exact path="/store/:id">
              <Store />
            </Route>
            <Route exact path="/cart">
              <Cart />
            </Route>
            <Route exact path="/cart-empty">
              <EmptyCart />
            </Route>
            <Route exact path="/register">
              <AccountCreate
                updateParentUserDataState={this.updateParentUserDataState}
              />
            </Route>
            <Route exact path="/login">
              <Login
                isLoggedIn={this.state.isLoggedIn}
                updateParentUserDataState={this.updateParentUserDataState}
              />
            </Route>
            <Route exact path="/reset_password">
              <ForgotPassword
                isLoggedIn={this.state.isLoggedIn}
                updateParentUserDataState={this.updateParentUserDataState}
              />

            </Route>
            <Route exact path='/password-reset'>
              <ForgotPasswordConfirm
                isLoggedIn={this.state.isLoggedIn}
                updateParentUserDataState={this.updateParentUserDataState}
              />
            </Route>
            <Route exact path="/Logout">
              <Logout
                isLoggedIn={this.state.isLoggedIn}
                updateParentUserDataState={this.updateParentUserDataState} />
            </Route>
            <Route exact path="/logout">
              <Logout
                isLoggedIn={this.state.isLoggedIn}
                updateParentUserDataState={this.updateParentUserDataState} />
            </Route>

            <Route exact path="/account-details">
              <AccountDetailsListing />
            </Route>
            <Route exact path="/account-addresses">
              <AccountDetailsListing />
            </Route>
            <Route exact path="/account-wishlist">
              <AccountDetailsListing />
            </Route>
            <Route exact path="/account-history">
              <AccountDetailsListing />
            </Route>
            <Route exact path="/account-balance">
              <AccountDetailsListing />
            </Route>
            <Route exact path="/account-balance/recharge">
              <AccountDetailsListing />
            </Route>
            <Route exact path="/account-balance/recharge/:id">
              <AccountDetailsListing />
            </Route>
            <Route exact path="/checkout">
              <Checkout isLoggedIn={this.state.isLoggedIn} />
            </Route>
            <Route exact path="/invoice">
              <Invoice />
            </Route>
            <Route exact path="/pages/about-us">
              <AboutUs />
            </Route>
            <Route exact path="/pages/contact-us">
              <ContactUs />
            </Route>
            <Route exact path="/policies/refund-policy">
              <RefundPolicy />
            </Route>
            <Route exact path="/policies/privacy-policy">
              <PrivacyPolicy />
            </Route>
            <Route exact path="/policies/shipping-policy">
              <ShippingPolicy />
            </Route>
            <Route exact path="/*">
              <Error404 />
            </Route>
          </Switch>
        </Suspense>
        <Footer />
        {/* {this.resetJqueries()} */}
      </div>
    )
  }
}


// const AppWithUserConsumer = WithUserConsumer(App)
// export default withRouter(App)

const mapStateToProps = state => ({
  cart_reducer: state.cart_reducer,
  wishlist_reducer: state.wishlist_reducer,
  points_reducer: state.points_reducer,
});

const mapDispatchToProps = () => {
  return {
    incrementCart, decrementCart, addToWishlist, removeFromWishlist, replaceCart, replaceWishlist, replacePoints
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps()
)(withRouter(App));


